<template>
    <button
        :type="type"
        class="app-btn"
        :class="[`app-btn--${variant}`, `app-btn--${size}`, { 'app-btn--block': block, 'app-btn--done': done }]"
        :disabled="disabled || done"
        v-on="$listeners"
    >
        <slot />
    </button>
</template>

<script>
// <app-button variant="cta" size="md" block @click="...">Sign Up</app-button>
//   variant  primary (brand gradient) | cta (sign-up gradient) | outline
//   size     sm | md | lg
//   done     finished state (e.g. already claimed): muted and not clickable
// Layout (flex, width, margins) belongs to the parent's class.
export default {
    name: 'AppButton',
    props: {
        variant: {
            type: String,
            default: 'primary',
            validator: v => ['primary', 'cta', 'outline'].includes(v)
        },
        size: {
            type: String,
            default: 'md',
            validator: v => ['sm', 'md', 'lg'].includes(v)
        },
        block: { type: Boolean, default: false },
        done: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        type: { type: String, default: 'button' }
    }
};
</script>

<style lang="scss" scoped>
.app-btn {
    border: none;
    font-family: 'Urbanist', sans-serif;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;

    &:disabled:not(.app-btn--done) {
        opacity: 0.5;
        cursor: not-allowed;
    }
}

.app-btn--primary {
    background: linear-gradient(180deg, var(--primary) 0%, var(--primary-deep) 100%);
    color: var(--text);
}

.app-btn--cta {
    background: linear-gradient(180deg, var(--cta-from) 0%, var(--cta-to) 100%);
    color: var(--text-on-cta);
}

.app-btn--outline {
    background: transparent;
    border: 1px solid var(--primary);
    color: var(--text);
}

.app-btn--sm {
    padding: 6px 14px;
    font-size: 12px;
    border-radius: 5px;
}

.app-btn--md {
    padding: 7px 14px;
    font-size: 14px;
    border-radius: 5px;
}

.app-btn--lg {
    padding: 10px 14px;
    font-size: 14px;
    border-radius: 8px;
}

.app-btn--done {
    background: var(--surface-hover);
    color: var(--text-dim);
    cursor: not-allowed;
}

.app-btn--block {
    width: 100%;
}
</style>
